<ng-container *ngIf="alerts?.length; else singleAlert">
    <cds-alert-group
        [size]="size"
        status="warning"
    >
        <cds-alert
            *ngFor="let alert of alerts"
            [closable]="alert.closable ?? closable"
            (closeChange)="handleClose(alert)"
        >
            {{ alert.message }}
        </cds-alert>
    </cds-alert-group>
</ng-container>

<ng-template #singleAlert>
    <cds-alert-group
        [size]="size"
        [status]="alertType"
        *ngIf="alertType !== 'lightweight'; else lightweight"
    >
        <cds-alert 
            [closable]="closable" 
            (closeChange)="onAlertClose.emit()"
        >
            <ng-content></ng-content>
        </cds-alert>
    </cds-alert-group>
</ng-template>

<ng-template #lightweight>
    <div class="avi-alert-group__alert">
        <cds-icon
            status="info" 
            shape="info-circle" 
            size="36"
        ></cds-icon>
        <div class="avi-alert-group__deprecation-message">
            <p class="avi-alert-group__deprecation-message__deprecation-label">
                {{ deprecationLabel }}
            </p>
            <div 
                class="avi-alert-group__deprecation-message__redirection-link"
                (click)="redirectToExternalLink()"
                (keydown.enter)="redirectToExternalLink()"
            >
                {{ globalL10nKeys.seeDetailsLabel | vtranslate }}
            </div>
        </div>
    </div>
</ng-template>
